import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import LiveMonitor from './pages/LiveMonitor';
import Campaigns from './pages/Campaigns';
import Leads from './pages/Leads';
import Agents from './pages/Agents';
import Teams from './pages/Teams';
import CIDGroups from './pages/CIDGroups';
import Dispositions from './pages/Dispositions';
import Reports from './pages/Reports';
import Recordings from './pages/Recordings';
import DNCList from './pages/DNCList';
import Appointments from './pages/Appointments';
import Advisors from './pages/Advisors';
import Rendezvous from './pages/Rendezvous';
import LeadLists    from './pages/LeadLists';
import LeadRecycle  from './pages/LeadRecycle';
import Settings from './pages/Settings';
import Security from './pages/Security';
import CongestionBanner from './components/CongestionBanner';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',color:'#8b949e' }}>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// Admin-only routes (Karim 2026-10-14): supervisors are EXTERNAL teams and get
// Live Monitor + Recordings ONLY — everything else bounces them to /monitor.
function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user && user.role === 'supervisor') return <Navigate to="/monitor" replace />;
  return children;
}

import SuspensionGate from './components/SuspensionGate';

function AppRoutes() {
  const { user } = useAuth();
  return (
    <>
    {user && <CongestionBanner />}
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<AdminRoute><Dashboard /></AdminRoute>} />
        <Route path="monitor" element={<LiveMonitor />} />
        <Route path="recordings" element={<Recordings />} />
        <Route path="campaigns" element={<AdminRoute><Campaigns /></AdminRoute>} />
        <Route path="leads" element={<AdminRoute><Leads /></AdminRoute>} />
        <Route path="agents" element={<AdminRoute><Agents /></AdminRoute>} />
        <Route path="teams" element={<AdminRoute><Teams /></AdminRoute>} />
        <Route path="cid" element={<AdminRoute><CIDGroups /></AdminRoute>} />
        <Route path="dispositions" element={<AdminRoute><Dispositions /></AdminRoute>} />
        <Route path="reports" element={<AdminRoute><Reports /></AdminRoute>} />
        <Route path="dnc" element={<AdminRoute><DNCList /></AdminRoute>} />
        <Route path="lead-lists"   element={<AdminRoute><LeadLists /></AdminRoute>} />
        <Route path="lead-recycle" element={<AdminRoute><LeadRecycle /></AdminRoute>} />
        <Route path="appointments" element={<AdminRoute><Appointments /></AdminRoute>} />
        <Route path="rendezvous" element={<AdminRoute><Rendezvous /></AdminRoute>} />
        <Route path="advisors" element={<AdminRoute><Advisors /></AdminRoute>} />
        <Route path="settings" element={<AdminRoute><Settings /></AdminRoute>} />
        <Route path="security" element={<AdminRoute><Security /></AdminRoute>} />
      </Route>
    </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <SuspensionGate role="admin" />
      <AppRoutes />
    </AuthProvider>
  );
}
